import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';


// 懒加载页面组件
const Home = React.lazy(() => import('./pages/Home'));
const Services = React.lazy(() => import('./pages/Services'));
const Answer = React.lazy(() => import('./pages/Answer'));
const About = React.lazy(() => import('./pages/About'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Cases = React.lazy(() => import('./pages/Cases'));
const CaseDetail = React.lazy(() => import('./pages/CaseDetail'));
const Equipment = React.lazy(() => import('./pages/Equipment'));
const Service = React.lazy(() => import('./pages/Service'));
const ServiceDetail = React.lazy(() => import('./pages/ServiceDetail'));
const EquipmentDetail = React.lazy(() => import('./pages/EquipmentDetail'));
const FireServiceDetail = React.lazy(() => import('./pages/FireServiceDetail'));

// 咨询详情页面
const FireExtinguisherMaintenance = React.lazy(() => import('./pages/consultation/FireExtinguisherMaintenance'));
const FireSafetyAssessment = React.lazy(() => import('./pages/consultation/FireSafetyAssessment'));

// 管理页面
const Admin = React.lazy(() => import('./pages/Admin'));

// 加载组件
const LoadingSpinner: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen bg-white">
    <div className="w-9 h-9 rounded-full border border-primary-200 border-t-primary-600 animate-spin"></div>
  </div>
);

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <ErrorBoundary>
          <div className="App min-h-screen flex flex-col">
            <Header />
            <Navbar />
            <main className="flex-1">
              <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/equipment" element={<Equipment />} />
                  <Route path="/services/service" element={<Service />} />
                  <Route path="/services/detail/:id" element={<ServiceDetail />} />
                  <Route path="/equipment/detail/:id" element={<EquipmentDetail />} />
                  <Route path="/service/detail/:id" element={<FireServiceDetail />} />
                  <Route path="/answer" element={<Answer />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/cases" element={<Cases />} />
                  <Route path="/cases/:id" element={<CaseDetail />} />
                  {/* 咨询详情页面路由 */}
                  <Route path="/consultation/fire-extinguisher-maintenance" element={<FireExtinguisherMaintenance />} />
                  <Route path="/consultation/fire-safety-assessment" element={<FireSafetyAssessment />} />
                  
                  {/* 管理页面路由 */}
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
          </div>
        </ErrorBoundary>
      </Router>
    </HelmetProvider>
  );
};

export default App; 